import { SESSION_OVERRIDE_KEY } from "./constants";

export const readSessionOverride = (): "metric" | "yards" | null => {
  try {
    const stored = sessionStorage.getItem(SESSION_OVERRIDE_KEY);
    if (stored === "metric" || stored === "yards") {
      return stored;
    }
  } catch (error) {
    console.error("Failed to read session unit override:", error);
  }
  return null;
};
